



































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { UpdateSupplierInfo } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import { VImageUpload } from '@/components/upload'
import constan from '@/utils/constant'

@Component({
  components: { VImageUpload },
})
export default class UpdateSupplierDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private isDesc!: boolean
  private show = false
  private data: any = {}
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    activityTheme: [this.requiredRule],
    activityStartTime: [this.requiredRule],
  }
  private supplierStatus = constan.SupplierStatus
  private supplierShopType = constan.SupplierShopType

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
    this.data = {}
  }
  public open(data: any) {
    this.show = true
    this.data = data
    if (this.data.supplierDescImg) {
      console.log('open')
      this.data.supplierDescImgList = this.data.supplierDescImg.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.supplierDescImgList = []
    }
    console.log(this.data.supplierDescImgList)
  }

  public async save() {
    if (this.isDesc) {
      this.close()
      return
    }
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      this.data.supplierDescImg = this.data.supplierDescImgList.map((e: any) => e.url).join(',')
      await UpdateSupplierInfo(this.data)
      Message.success('保存')
      this.close()
    })
  }
}
